/**
 * QaReasonsAdmin.tsx — Admin > Q/A Reasons.
 *
 * The corporate dashboard's Q/A Reasons page for the signed-in account (see
 * ReasonListAdmin for the list and form). Reads and writes /v5/qa-reasons,
 * where a delete is reversible (Show deleted, Restore).
 */
import { ReasonListAdmin } from '@/components/admin/ReasonListAdmin';
import { qaReasonsApi } from '@/services/reasons.service';

const TEXT = {
  title: 'Q/A Reasons',
  subtitle: 'Manage Q/A reasons.',
  noun: ['reason', 'reasons'] as [string, string],
  thing: 'Q/A reason',
  searchLabel: 'Search Q/A reasons',
  emptyTitle: 'No Q/A reasons found',
  idPrefix: 'qa-reasons',
};

export function QaReasonsAdmin() {
  return <ReasonListAdmin api={qaReasonsApi} text={TEXT} />;
}
